/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import {
  ProductCard,
  SpanWithData,
  DisplayAmount,
  FuneralPolicyBeneficiary,
} from '../'

import {
  COLOUR_FUNERAL_COVER_1,
  COLOUR_FUNERAL_COVER_2
} from '../../constants'


export class FuneralCoverProductCard extends React.PureComponent {
  static propTypes = {
    // TODO: update
    policyId: PropTypes.string.isRequired,
    policyNumber: PropTypes.string,
    contributionType: PropTypes.string,
    status: PropTypes.string,
    statusDetails: PropTypes.string,
    coverCost: PropTypes.string.isRequired,
    activatedAt: PropTypes.string,
    coveredFrom: PropTypes.string,
    coveredUntil: PropTypes.string,
    gracePeriodEndsAt: PropTypes.string,
    waitingPeriodData: PropTypes.arrayOf(PropTypes.string),
    detailLink: PropTypes.string,
    onDetailLinkClick: PropTypes.func,
    detailView: PropTypes.bool,
    className: PropTypes.string
  }

  render() {
    let {
      policyId,
      policyType,
      policyNumber,
      paidBy,
      statusDetails,
      coverCost,
      coveredFor,
      activatedAt,
      coveredFrom,
      coveredUntil,
      gracePeriodEndsAt,
      waitingPeriodData
    } = this.props

    let {
      starts_at: waitingPeriodStartsAt,
      ends_at: waitingPeriodEndsAt,
      skipped_payments: skippedPayments,
      status
    } = JSON.parse(waitingPeriodData)

    let secondaryDetails = this.props.detailView
      ? {
        'Covered for': <DisplayAmount amountString={coveredFor} />,
        'Cover cost': <DisplayAmount amountString={coverCost} />,
        'Covered from': coveredFrom
        ? moment(coveredFrom).format("D MMM 'YY")
        : 'Unknown',
        'Covered until': coveredUntil
        ? moment(coveredUntil).format("D MMM 'YY")
        : 'Unknown',
        'Policy number': policyNumber || 'Unknown',
        'Status details': <SpanWithData
          forField='ClientFuneralPolicyStatusDetails'
          searchKey={statusDetails}
        />,
        'Activated at': activatedAt
          ? moment(activatedAt).format("D MMM 'YY")
          : 'Unknown',
        'Grace period end': gracePeriodEndsAt
          ? moment(gracePeriodEndsAt).format("D MMM 'YY")
          : 'Unknown',
        'Waiting period start': waitingPeriodStartsAt
            ? moment(waitingPeriodStartsAt).format("D MMM 'YY")
            : 'Unknown',
        'Waiting period end': waitingPeriodEndsAt
            ? moment(waitingPeriodEndsAt).format("D MMM 'YY")
            : 'Unknown',
        'Skipped payments': skippedPayments,
        'Status': status
      }
      : {
        'Cover cost': <DisplayAmount amountString={coverCost} />,
        'Policy number': policyNumber || 'Unknown',
        'Cover start': coveredFrom
          ? moment(coveredFrom).format("D MMM 'YY")
          : 'Unknown',
        'Cover end': coveredUntil
          ? moment(coveredUntil).format("D MMM 'YY")
          : 'Unknown'
      }

    if (policyType === 'EXTENDED_FAMILY' && this.props.detailView) {
      secondaryDetails['Cover beneficiary'] = <FuneralPolicyBeneficiary policy={policyId} />
    }

    return (
      <ProductCard
        title='funeral cover'
        subtitle={{
          'Paid by': <SpanWithData
            forField='ClientFuneralPolicyPaidBy'
            searchKey={paidBy}
          />,
          'Policy type': <SpanWithData
            forField='ClientFuneralPolicyPolicyType'
            searchKey={policyType}
          />
        }}
        product='funeral_cover'
        secondaryDetails={secondaryDetails}
        footerText='Detail and history'
        footerLink={this.props.detailLink}
        onFooterLinkClick={() => this.props.onDetailLinkClick(policyId)}
        hideFooter={this.props.detailView}
        backgroundColour={COLOUR_FUNERAL_COVER_1}
        footerBackgroundColour={COLOUR_FUNERAL_COVER_2}
        className={`u-bg-color-white ${this.props.className ? this.props.className : ''}`}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/funeral-cover-product-card/index.js